import { connect } from 'react-redux';

import {
  projectsCreate,
  projectSetSystem,
} from 'actions';

import View from './';

const mapStateToProps = state => ({
  intl: state.intl,
  loading: state.projects.single.post.loading || state.projects.single.setSystem.loading,
});

const mapDispatchToProps = (dispatch) => {
  return {
    projectsCreate(payload) {
      return dispatch(projectsCreate(payload));
    },
    projectSetSystem(payload) {
      return dispatch(projectSetSystem(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./js/views/systems/info-modal/container.js